import '../manse.css';
import { STEM_HANJA, BRANCH_HANJA, STEM_EL, BRANCH_EL, HIDDEN_STEMS, sipseong, polarity, branchPolarity } from '../lib/hanja.js';

const ELEMENT_KO = ['목', '화', '토', '금', '수'];
const POLARITY_KO = { 陽: '양', 陰: '음' };

// 만세력 스타일 사주 원국: 시주 · 일주 · 월주 · 년주 순서, 천간 위 / 지지 아래, 십성과 지장간 포함
const COLS = [['hour', '시주'], ['day', '일주'], ['month', '월주'], ['year', '년주']];

function Glyph({ ch, el, sub }) {
  return (
    <div className={`mglyph el${el}`}>
      <b>{ch}</b>
      <small>{sub}</small>
    </div>
  );
}

export default function ManseTable({ saju, compact = false }) {
  const dayStem = saju.day.stem;
  return (
    <div className={`manse ${compact ? 'compact' : ''}`}>
      {COLS.map(([k, label]) => <div key={`h${k}`} className="mhead">{label}</div>)}

      {COLS.map(([k]) => {
        const p = saju[k];
        return <div key={`ss${k}`} className="mten">{!p ? '' : k === 'day' ? '일간 (나)' : sipseong(dayStem, p.stem)}</div>;
      })}
      {COLS.map(([k]) => {
        const p = saju[k];
        return p ? <Glyph key={`s${k}`} ch={STEM_HANJA[p.stem]} el={STEM_EL[p.stem]} sub={`${POLARITY_KO[polarity(p.stem)]}${ELEMENT_KO[STEM_EL[p.stem]]}`} />
          : <div key={`s${k}`} className="mglyph unknown"><b>?</b><small>모름</small></div>;
      })}
      {COLS.map(([k]) => {
        const p = saju[k];
        return p ? <Glyph key={`b${k}`} ch={BRANCH_HANJA[p.branch]} el={BRANCH_EL[p.branch]} sub={`${POLARITY_KO[branchPolarity(p.branch)]}${ELEMENT_KO[BRANCH_EL[p.branch]]}`} />
          : <div key={`b${k}`} className="mglyph unknown"><b>?</b><small>모름</small></div>;
      })}
      {COLS.map(([k]) => {
        const p = saju[k];
        return <div key={`bt${k}`} className="mten">{p ? sipseong(dayStem, HIDDEN_STEMS[p.branch][0]) : ''}</div>;
      })}
    </div>
  );
}
